import script from "./HeaderAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderAlerts.vue?vue&type=script&setup=true&lang=js"

import "./HeaderAlerts.vue?vue&type=style&index=0&id=3d506252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d506252"]])

export default __exports__